import { UcoastEl } from '@/scripts/core/UcoastEl'
import { qsRequired, removeTrapFocus, trapFocus } from '@/scripts/core/global'

export class SelectShadeTooltip extends UcoastEl {
	static htmlSelector = 'select-shade-tooltip'
	closeButton: HTMLButtonElement
	summary: HTMLElement
	details: HTMLDetailsElement
	constructor() {
		super()
		this.closeButton = qsRequired('[data-close]', this)
		this.summary = qsRequired('summary', this)
		this.details = qsRequired('details', this)
		this.summary.addEventListener('click', (_) => {
			trapFocus(this.details)
		})
		this.closeButton.addEventListener('click', (e) => {
			e.preventDefault()
			this.details.removeAttribute('open')
			this.summary.setAttribute('aria-expanded', 'false')
			removeTrapFocus(this.summary)
		})
	}
}
